import type React from "react";
import { ShieldCheck } from "lucide-react";
import { ModerationRulesetManagement } from "@/components/catalog/moderation-rulesets/moderation-ruleset-management";

const ModerationRulesPage: React.FC = () => {
  return (
    <main className="flex-1 space-y-6 p-2">
      <div className="space-y-2">
        <h1 className="text-3xl font-bold tracking-tight">Moderation rules</h1>
        <p className="text-muted-foreground">
          Create reusable rulesets, manage individual rule versions, and choose which catalogues use them.
        </p>
      </div>

      <div className="rounded-md border bg-muted/20 p-3 text-sm text-muted-foreground">
        <ShieldCheck className="mr-2 inline h-4 w-4" />
        This is the only place to create or change moderation rules. Catalogue pages show assignment status only.
      </div>

      <ModerationRulesetManagement />
    </main>
  );
};

export default ModerationRulesPage;
